/* 
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetTaxFiles = (vendor: string) => {
  const [taxFiles, setTaxFiles] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { get } = useAbortController();

  const getTaxFiles = useCallback(async () => {
    if (!token || !vendor) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const url = process.env.REACT_APP_TAX_PAYMENT + vendor;

    const controller = get();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    const formData = {
      listFiles: true,
    };

    try {
      let response = await axiosCall({ url: url, method: 'post', data: formData }, config, headers);
      setTaxFiles(response.files);
      setLoading(false);
    } catch (error) {
      setErrorMessage('Error Loading Tax Files.');
      setLoading(false);
      console.error(error.message);
    }
  }, [vendor, get]);

  useEffect(() => {
    getTaxFiles();
  }, [getTaxFiles]);

  return {
    taxFiles: taxFiles,
    taxFilesErrorMessages: errorMessage,
    loadingTaxFiles: loading,
  };
};

export default useGetTaxFiles;
